import { AuthContext } from "../context/AuthContext"
import { useContext } from "react"
import useViewModeStore from "../store/viewMode/useViewModeStore"

export const useAuthContext = () => {
  const context = useContext(AuthContext)
  const { isViewMode, viewingAs } = useViewModeStore()

  if (!context) {
    throw Error("useAuthContext must be used inside an AuthContextProvider")
  }

  // When in view mode, override all role fields with the viewed user's roles.
  // The real `user` (Firebase Auth object) stays intact so Firestore operations
  // still run as the actual logged-in admin.
  if (isViewMode && viewingAs) {
    const roles = viewingAs.roles || {}
    return {
      ...context,
      firestoreData: viewingAs.firestoreData,
      admin: roles.admin ?? false,
      semiAdmin: roles.semiAdmin ?? false,
      paperManager: roles.paperManager ?? false,
      designer: roles.designer ?? false,
      accountant: roles.accountant ?? false,
      arsomaUser: roles.arsomaUser ?? false,
      vivaUser: roles.vivaUser ?? false,
      warehouse: roles.warehouse ?? false,
      winder: roles.winder ?? false,
      tapeUser: roles.tapeUser ?? false,
      cutter: roles.cutter ?? false,
      devSpecialist: roles.devSpecialist ?? false,
      sales: roles.sales ?? false,
      // Escape hatch — lets components check if they're in view mode
      _isViewMode: true,
      _viewingAs: viewingAs,
      _realContext: context,
    }
  }

  return context
}
